export default __webpack_public_path__ + "static/media/crash.93f59e9e.png";